export default "__VITE_ASSET__f12hLGNv__"